<template>
  <div :class="[isFixed ? 'fixed-wrap' : '', isMobile ? 'mobile-cls' : '']">
    <div class="header-wrap" :style="{ 'background-color': bgColor }">
      <header>
        <img
          class="logo-cls"
          src="@/assets/major/logo-title.png"
          alt="发发"
          title="发发"
          @click="goHome"
        />
        <!-- <div class="right-cls" v-if="!isMobile">
          <div class="a-cls login-a" @click="goLogin" v-if="!isLogin">
            注册/登录
          </div>
          <div class="a-cls login-a" @click="goUser" v-else>用户中心</div>
        </div> -->
      </header>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="consultShow"
      width="442px"
      custom-class="dialog-cls business-dialog"
      @close="closeFn"
      :close-on-click-modal="false"
    >
      <template v-if="!submitSuccess">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="left"
          label-width="108px"
        >
          <el-form-item label="联系人姓名" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入联系人姓名"
              clearable
              maxlength="15"
            />
          </el-form-item>
          <el-form-item label="联系人账户" prop="cell_phone">
            <el-input
              v-model.trim="form.cell_phone"
              placeholder="请输入联系人的账户"
              clearable
              maxlength="11"
            />
          </el-form-item>
          <el-form-item label="联系人邮箱" prop="email">
            <el-input
              v-model.trim="form.email"
              placeholder="请输入联系人邮箱"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-button class="btn-cls" type="primary" @click="submitForm" style="border-radius: 10px!important;"
            >提交咨询</el-button
          >
          <div class="btn-tag-cls">提交以后工作人员将1-3个工作日内联系你</div>
        </el-form>
      </template>
      <template v-else>
        <div class="success-box">
          <i class="el-icon-success"></i>
          <div class="title-cls">信息已提交</div>
          <div class="success-tag">
            提交申请后工作 人员将在1-3个工作日内联系你，请耐心等待
          </div>
          <el-button class="btn-cls" type="primary" @click="closeFn"
            >好的，我知道了</el-button
          >
        </div>
      </template>
    </el-dialog>

    <!--  注册/登录  -->
    <el-dialog
      :title="title"
      :visible.sync="loginOpen"
      width="500px"
      custom-class="dialog-cls business-dialog"
      @close="closeFn"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        label-position="right"
        v-if="loginOpen"
      >
        <el-form-item label="账户" prop="cell_phone" v-if="dialogType == 1">
          <el-input
            v-model.trim="form.cell_phone"
            placeholder="请输入账户"
            clearable
            maxlength="11"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email" v-if="dialogType != 1">
          <el-input
            v-model.trim="form.email"
            placeholder="请输入邮箱地址"
            maxlength="30"
            clearable
          />
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="dialogType == 2">
          <div class="pwd-box">
            <el-input
              v-model.trim="form.password"
              placeholder="请输入密码"
              maxlength="20"
              :key="passwordType"
              ref="password"
              :type="passwordType"
              name="password"
              tabindex="2"
              autocomplete="off"
            />
            <span class="show-pwd" @click="showPwd">
              <img
                v-if="passwordType === 'password'"
                src="@/assets/eye-close.png"
                alt=""
              />
              <img v-else src="@/assets/eye.png" alt="" />
            </span>
          </div>
        </el-form-item>
        <el-form-item prop="code" label="验证码" v-if="dialogType != 2">
          <div style="height: 40px;display: flex">
            <el-input
              class="flex-1"
              v-model.trim="form.code"
              placeholder="请输入验证码"
              style="margin-right: 10px"
              maxlength="4"
            />
            <el-button
              v-if="codeShow"
              style="cursor:pointer;height: 38px;background-color: $--color-primary;border-radius: 4px;"
              type="primary"
              size="small"
              @click="getCodeFn()"
              class="code-btn"
            >
              {{ showText }}
            </el-button>
            <el-button
              v-if="!codeShow"
              style="cursor:pointer;height: 38px;"
              type="info"
              size="small"
              :disabled="countNum != 0"
              @click="getCodeAgain()"
              class="code-btn"
            >
              重新获取{{ countNum }}s
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          :label="dialogType == 4 ? '新密码' : '设置密码'"
          prop="password"
          v-if="dialogType == 3 || dialogType == 4"
        >
          <div class="pwd-box">
            <el-input
              v-model.trim="form.password"
              :placeholder="
                dialogType == 4
                  ? '请输入新密码'
                  : '请输入6-12位数字和字母组合的密码'
              "
              :key="passwordType"
              ref="password"
              :type="passwordType"
              name="password"
              tabindex="2"
              autocomplete="off"
              maxlength="20"
            />
            <span class="show-pwd" @click="showPwd">
              <img
                v-if="passwordType === 'password'"
                src="@/assets/eye-close.png"
                alt=""
              />
              <img v-else src="@/assets/eye.png" alt="" />
            </span>
          </div>
        </el-form-item>
        <el-form-item class="text-btn-item" v-if="dialogType != 1">
          <div class="text-btn-box" v-if="dialogType == 2">
            <div class="text-btn-cls" @click="dialogChange(4)">忘记密码</div>
            <div class="text-btn-cls" @click="dialogChange(3)">注册新账号></div>
          </div>
          <div class="text-btn-box" v-else>
            <div
              class="text-btn-cls text-right"
              v-if="dialogType == 3"
              @click="dialogChange(2)"
            >
              已有邮箱账号？去登录>
            </div>
            <div
              class="text-btn-cls text-right"
              v-if="dialogType == 4"
              @click="dialogChange(2)"
            >
              去登录>
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
            class="btn-cls login-btn-cls"
            style="border-radius: 4px!important;"
            v-if="dialogType == 1 || dialogType == 2"
            type="primary"
            @click="loginFn"
            >{{ dialogType == 1 ? "注册/" : "" }}登录
          </el-button>
          <el-button
            class="btn-cls login-btn-cls"
            v-else
            type="primary"
            @click="dialogType == 3 ? registerFn() : resetFn()"
          >
            {{ dialogType == 3 ? "注册" : "确定" }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="text-btn-cls" v-if="dialogType != 1" @click="dialogChange(1)" >
        手机注册/登录
      </div>
      <div class="text-btn-cls" v-else @click="dialogChange(2)">
        邮箱注册/登录
      </div>
      <div v-if="dialogType == 1">未注册手机验证后自动注册</div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCode,
  login,
  getEmailCode,
  resetPassword,
  goRegisterEmail
} from "@/api/apply";
export default {
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: "transparent"
    },
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback("请输入正确的账户");
      }
    };
    const checkEmail = (rule, value, callback) => {
      const reg = /^^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback("请输入正确的邮箱");
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (/^(?![a-zA-Z]+$)(?!\d+$).+/.test(value)) {
          callback();
        } else {
          callback(new Error("密码须由6-12位数字和字母组合而成"));
        }
      }
    };
    return {
      isLogin: false,
      loginOpen: false, //登录弹窗
      dialogType: 2, // 1手机登录 2 邮箱登录 3邮箱注册 4忘记密码
      showText: "获取验证码",
      codeShow: true,
      countNum: 60,
      consultShow: false,
      newPassword: {
        email: undefined,
        password: undefined
      },
      form: {
        name: undefined,
        cell_phone: undefined,
        code: undefined,
        email: undefined,
        password: undefined
      },
      submitSuccess: false,
      title: "",
      titleList: {
        1: "账号登录",
        2: "邮箱登录",
        3: "邮箱注册",
        4: "忘记密码"
      },
      rules: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        cell_phone: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        code: [{ required: true, message: "不能为空", trigger: "blur" }],
        email: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" }
        ],
        password: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      passwordType: 'password',
      routerPath: ''
    };
  },
  watch: {
    "form.password"(val) {
      if (val && typeof val === "string") {
        this.form.password = val.replace(/[^0-9A-Za-z]/g, "");
      }
    }
  },
  mounted () {
    this.routerPath = this.$route.path;
    let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
    if (clientWidth < 500) {
      this.isMobile = true
    }
  },
  methods: {
    /** 跳转到用户 */
    goBuy() {
      this.$router.push({path: '/user/meal'})
    },
    goHome() {
      this.$router.push("/");
    },
    goLogin() {
      // 清除定时器
      clearInterval(this.intervalBtn);
      this.title = "注册/登录";
      this.dialogType = 2;
      this.resetForm();
      this.showText = "获取验证码";
      this.countNum = 60;
      this.codeShow = true;
      // 判断用户是否邮箱登录，默认显示邮箱登录界面
      let userEmail = localStorage.getItem("login_email");
      if (userEmail) {
        this.dialogType = 2;
      }
      this.loginOpen = true;
    },
    resetForm() {
      this.form = {
        name: undefined,
        cell_phone: undefined,
        code: undefined,
        enterprise: undefined,
        business_license: undefined,
        enterprise_web: undefined,
        remark: undefined
      };
    },
    closeFn() {
      this.consultShow = false;
      this.loginOpen = false;
      this.$refs["form"].clearValidate();
    },
    dialogChange(type) {
      if (type != 2) {
        this.rules.password = [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            min: 6,
            max: 12,
            message: "密码需由6-12数字或者字母组成",
            trigger: "blur"
          },
          { validator: this.validatePass, trigger: "blur" }
        ];
      } else {
        this.rules.password = [
          { required: true, message: "不能为空", trigger: "blur" }
        ];
      }
      this.form = {
        name: undefined,
        cell_phone: undefined,
        code: undefined,
        email: undefined,
        password: undefined
      };
      // 清除定时器
      clearInterval(this.intervalBtn);
      this.showText = "获取验证码";
      this.countNum = 60;
      this.codeShow = true;
      this.title = this.titleList[type];
      this.passwordType = "password";
      this.$refs["form"].clearValidate();
      this.dialogType = type;
      if (type == 2 && this.newPassword.password) {
        this.form.email = this.newPassword.email;
        this.form.password = this.newPassword.password;
      } else {
        this.newPassword = {
          email: undefined,
          password: undefined
        };
      }
    },
    // 倒计时
    countDown() {
      // 更改btn状态
      this.codeShow = !this.codeShow;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 清除定时器
          clearInterval(this.intervalBtn);
          // 更改btn状态
          this.codeShow = !this.codeShow;
          // 重置倒计时状态
          this.countNum = 60;
        }

        // 倒计时
        this.countNum--;
      }, 1000);
    },
    /** 跳转到用户 */
    goUser() {
      this.$router.push({ path: "/user" });
    },
    getCodeAgain() {
      this.$message.warning("获取验证码频次过于频繁");
    },
    /** 获取验证码 */
    getCodeFn() {
      this.$refs["form"].validateField(
        this.dialogType == 1 ? "cell_phone" : "email",
        valid => {
          if (!valid) {
            this.countDown();
            if (this.dialogType == 1) {
              getCode({ phone: this.form.cell_phone }).then(res => {
                if (res.code === 200) {
                  this.$message.success("发送成功");
                  this.showText = "重新获取";
                } else {
                  this.$message.error(res.msg);
                }
              });
            } else {
              getEmailCode({ email: this.form.email }).then(res => {
                if (res.code === 200) {
                  this.$message.success("发送成功");
                  this.showText = "重新获取";
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          }
        }
      );
    },
    /** 提交咨询 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          addApply(this.form)
            .then(res => {
              if (res.code === 200) {
                this.title = "提交成功";
                this.submitSuccess = true;
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.$message.error(err.msg);
            });
        }
      });
    },
    /** 登录 */
    loginFn() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let params = {
            cell_phone: this.form.cell_phone,
            code: this.form.code,
            email: this.form.email,
            password: this.form.password
          };
          this.$store
            .dispatch(this.dialogType == 1 ? "login" : "loginEmail", params)
            .then(res => {
              if (res.code === 200) {
                this.$message.success("登录成功");
                this.loginOpen = false;
                this.isLogin = true;
                localStorage.setItem("login_user", res.token);
                if (this.dialogType == 1) {
                  localStorage.setItem("login_phone", this.form.cell_phone);
                  localStorage.removeItem("login_email");
                } else {
                  localStorage.removeItem("login_phone");
                  localStorage.setItem("login_email", this.form.email);
                }
                setTimeout(() => {
                  this.goUser();
                }, 1000);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.$message.error(err.msg);
            });
        }
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    registerFn() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let params = {
            email: this.form.email,
            code: this.form.code,
            password: this.form.password
          };
          goRegisterEmail(params).then(res => {
            if (res.code === 200) {
              this.$message.success("注册成功");
              setTimeout(() => {
                this.loginFn();
              }, 600);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    /** 重置 */
    resetFn() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let params = {
            email: this.form.email,
            code: this.form.code,
            password: this.form.password
          };
          resetPassword(params).then(res => {
            if (res.code === 200) {
              this.$message.success("重置成功");
              this.newPassword.email = this.form.email;
              this.newPassword.password = this.form.password;
              setTimeout(() => {
                this.dialogChange(2);
              }, 600);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    }
  },
  created() {
    let userInfo = localStorage.getItem("login_user");
    if (userInfo) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  }
};
</script>
<style>
body.no-scroll {
  overflow: hidden; /* 隐藏滚动条 */
  padding-right: 17px; /* 17px是常见的滚动条宽度，根据实际情况调整 */
}
</style>
<style lang="scss">
@import "@/assets/css/style";
::v-deep .business-dialog {
}
.fixed-wrap {
  .header-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    overflow-y: scroll;
  }
  &:after {
    content: "";
    display: block;
    height: 146px;
    width: 100%;
  }
}

.mobile-cls{
  header {
    align-items: flex-start !important;
  }
  .a-link {
    display: block !important;
    position: relative;
    background: none !important;
    border: none !important;
  }
  .link-cs {
    top: 2.56rem;
    border-radius: px2rem(24);
    width: 2.66667rem;
    height: 0.85333rem;
    right: 0.37333rem !important;
    left: auto !important;
    font-size: px2rem(26);

    img {
      width: px2rem(49);
      height: px2rem(49);
      margin-right: px2rem(11)
    }
  }
}
@media screen and (min-width: 1000px) {
  .header-wrap {
    header {
      width: 100%;
      max-width: 1200px;
      margin: auto;
      display: flex;
      padding-top: 39px;
      align-items: center;
      justify-content: space-between;
      .logo-cls {
        height: 58px;
        cursor: pointer;
      }

      a {
        color: #fff;
        text-decoration: none;
        cursor: pointer;
        font-weight: bold;
        line-height: 1;
        font-size: 22px;
      }
    }

    .a-cls {
      color: #000;
      cursor: pointer;
      background: #fff;
      border-radius: 12px;
      font-size: 14px;
      min-width: 100px;
      line-height: 40px;
      box-sizing: border-box;
      font-weight: 400;
      display: inline-block;
      margin-left: 12px;
      text-align: center;
    }
    .a-cls:hover {
      background: $--color-gradient-green;
      color: #fff;
    }

    .blue-btn{
      background: $--color-gradient-green;
      color: #fff;
    }
    .blue-btn:hover{
      opacity: 0.8;
    }
  }
  .dialog-cls {
    text-align: center;
    border-radius: 20px !important;
    .el-dialog__body {
      padding: 5px 30px 20px;
    }
    .el-dialog__header {
      font-weight: bold;
    }

    .el-form-item__label {
      font-weight: 700;
      color: #111;
    }

    .btn-cls {
      width: 300px !important;
      height: 48px !important;
      background: $--color-primary !important;
      border-radius: 12px !important;
      color: #fff !important;
      font-size: 16px !important;
      display: inline-block;
      cursor: pointer;
    }
    .success-box {
      line-height: 1.6;

      i {
        font-size: px2rem(100);
        color: $--color-primary;
      }

      .title-cls {
        font-size: 16px;
        color: #000;
        margin: px2rem(20) 0;
        font-weight: bold;
      }

      .success-tag {
        border-top: 1px solid #e5e5e5;
        margin-top: px2rem(28);
        padding: px2rem(28) 0;
      }
    }

    .btn-tag-cls {
      color: #000;
      margin-top: 14px;
    }
  }
}
@media screen and (max-width: 999px) {
  .header-wrap {
    header {
      padding: px2rem(28);
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .faq {
        display: none !important;
      }
      img {
        width: px2rem(380);
      }

      a {
        display: none !important;
      }

      .login-a {
        display: none !important;
      }

      .a-cls {
        width: px2rem(200);
        height: px2rem(64);
        line-height: px2rem(64);
        background: #fff;
        border-radius: px2rem(24);
        color: #040027;
        text-align: center;
        font-size: px2rem(27);
      }
      .right-cls{
        display: flex;
        flex-direction: column;
        .a-cls{
          display: inline-flex;
          justify-content: center;
           align-items: center;
          margin-bottom: px2rem(20);
        }
      }
    }
  }
  .dialog-cls {
    text-align: center;
    width: 90% !important;
    max-width: 442px;
    border-radius: px2rem(24) !important;
    .el-dialog__header {
      padding-bottom: 0 !important;
      font-weight: bold;
    }

    .btn-cls {
      width: 100%;
      max-width: 80%;
      //height: px2rem(80);
      background: $--color-gradient-green;
      border-radius: px2rem(60);
      color: #fff;
      //font-size: px2rem(32);
      font-size: 16px;
      display: inline-block;
    }

    //.code-btn {
    //  background: $--color-primary;
    //  border: 1px solid $--color-primary;
    //}

    .btn-tag-cls {
      color: #999;
      margin-top: 14px;
    }
    .success-box {
      line-height: 1.6;

      i {
        font-size: px2rem(100);
        color: $--color-primary;
      }

      .title-cls {
        font-size: px2rem(32);
        color: #000;
        margin: px2rem(20) 0;
        font-weight: bold;
      }

      .success-tag {
        border-top: 1px solid #e5e5e5;
        margin-top: px2rem(28);
        padding: px2rem(28) 0;
      }
    }
  }
}
</style>
